export const home = {
  'home.title': 'subvention360',

  // Narrative hook
  'home.hero.hook': 'Each year, €3 billion in French subsidies go unclaimed.',
  'home.hero.hookSub': 'Not because businesses don\'t qualify — but because finding the right grant is too complex.',

  // Hero section - Problem/Solution narrative
  'home.hero.title': 'Find €10K-€500K in French Subsidies',
  'home.hero.titleHighlight': 'Without Wasting 20 Hours Searching',
  'home.hero.mission': 'subvention360 exists to fix this. We believe every entrepreneur, nonprofit, and regional agency deserves equal access to public funding — in minutes, not months.',
  'home.hero.description': '144,434 subsidies centralized • Validated AI matching (+231.8% accuracy) • Results in 5 minutes',
  'home.hero.cta.primary': '🎯 Find Your Grants Now',
  'home.hero.cta.noCard': 'No upfront payment required',
  'home.hero.cta.tryFree': 'Get Started Free',

  // Live metrics
  'home.metrics.title': '📊 Live Stats',
  'home.metrics.subsidies': 'Subsidies',
  'home.metrics.successRate': 'Success Rate',
  'home.metrics.funding': 'Secured by Our Clients',
  'home.metrics.updated': 'Updated daily',

  // Social proof section
  'home.socialProof.title': '💬 Trusted By',
  'home.socialProof.quote1': 'subvention360 saved me 15 hours per week.',
  'home.socialProof.author1': 'Marie, Consultant',
  'home.socialProof.quote2': '€280K secured in 6 months thanks to subvention360.',
  'home.socialProof.author2': 'Pierre, Startup CEO',
  'home.socialProof.quote3': 'Without subvention360, we would have missed the EIC Accelerator.',
  'home.socialProof.author3': 'Sophie, CTO',

  // Competitive advantage section
  'home.competitive.title': '🆚 Why subvention360?',
  'home.competitive.vsConsultants': 'vs Consultants',
  'home.competitive.vsConsultantsValue': '€9.99 instead of €5K-€15K',
  'home.competitive.vsAidesTerritoires': 'vs Aides-Territoires',
  'home.competitive.vsAidesTerritoiresValue': '144,434 grants (vs 7,000)',
  'home.competitive.vsManual': 'vs Manual Search',
  'home.competitive.vsManualValue': '5 min (vs 20 hours)',

  // Features section
  'home.features.noAccount.title': 'No Registration Required',
  'home.features.noAccount.aiSearch': 'Describe your project and AI finds matching subsidies',
  'home.features.noAccount.explore': 'Explore thousands of grants with clear explanations',
  'home.features.noAccount.discover': 'Find expert advisors to guide you',
  'home.features.noAccount.freeTriesNote': 'You have 3 free searches',

  'home.features.withAccount.title': 'With Your Account (Individuals & Professionals)',
  'home.features.personal.title': 'For You',
  'home.features.personal.recommendations': 'Personalized recommendations based on your profile and projects',
  'home.features.personal.save': 'Save your subsidies and track your applications',
  'home.features.personal.alerts': 'Automatic alerts for new opportunities',

  'home.features.professional.title': 'For Professionals',
  'home.features.professional.platform': 'Create your own platform for your clients',
  'home.features.professional.track': 'Track all current and past grants in your portfolio',
  'home.features.professional.dashboard': 'Professional dashboard to manage subsidy files',
  'home.features.professional.history': 'Complete history of funding secured by your clients',

  'home.features.summary': 'From startup funding to regional grants, from innovation to sustainable development - everything is here, made simple by AI.',

  // Trust indicators
  'home.trust.title': '🏆 Why Trust Us?',
  'home.trust.coverage': '144,434 French subsidies centralized',
  'home.trust.accuracy': '+231.8% accuracy vs manual search (validated)',
  'home.trust.speed': 'Results in 5 minutes instead of 20 hours',
  'home.trust.success': '67% success rate with our historical intelligence',

  // Final CTA
  'home.cta.title': 'Ready to Unlock Your Funding?',
  'home.cta.subtitle': 'Join thousands of entrepreneurs who have already secured €4.8M thanks to subvention360',
  'home.cta.button': 'Get Started Now',
  'home.trust': 'Thousands of entrepreneurs, nonprofits, and consultants already trust us.',

  // Privacy promise
  'home.privacy.title': '🔒 Your Data Stays Private',
  'home.privacy.promise': 'We NEVER resell your information. No sales calls. No solicitation. Your data is used solely to find YOUR subsidies.',
  'home.privacy.guarantee': '100% private • No spam • No unwanted calls',

  'home.loading': 'Loading...',

  // Product details section
  'home.productDetails.title': 'Want to learn more about our solution?',
  'home.productDetails.description': 'Discover in detail how subvention360 can transform the way you manage subsidies',
  'home.productDetails.button': 'Learn more about our product',

  // Tagline (brand positioning)
  'home.tagline': 'The intelligence that unlocks your funding',

  // B2B Landing Page (Consultant-focused)
  'home.b2b.header.pricing': 'Pricing',
  'home.b2b.header.login': 'Sign In',

  // B2B Hero Section
  'home.b2b.hero.title': 'Get in a few minutes the public funding best suited to each of your clients.',
  'home.b2b.hero.titleLine2': '',
  'home.b2b.hero.titleLine3': '',
  'home.b2b.hero.titleHighlight': '',
  'home.b2b.hero.description': 'Subvention360 identifies and personalizes all schemes: grants, repayable advances, preferential rate loans, guarantees, R&D tax credits and tax relief. A unified dashboard, real-time monitoring and a dedicated AI Assistant: complete support for every funding project.',
  'home.b2b.hero.tagline': 'Subvention360 identifies and personalizes all schemes: grants, repayable advances, preferential rate loans, guarantees, R&D tax credits and tax relief. A unified dashboard, real-time monitoring and a dedicated AI Assistant: complete support for every funding project.',
  'home.b2b.hero.tagline2': 'For accountants, consulting firms and consultants specialized in public funding to support their clients.',
  'home.b2b.hero.coverageTypes': 'All funding types: grants, repayable advances, preferential loans, guarantees, tax exemptions.',
  'home.b2b.hero.coverageScope': 'Local, regional, national and European public funding.',

  // B2B Stats (Updated December 2025)
  'home.b2b.stats.subsidies': '5,000+',
  'home.b2b.stats.subsidiesLabel': 'Referenced grants',
  'home.b2b.stats.targeted': '10 - 40 grants',
  'home.b2b.stats.targetedLabel': 'Targeted per client',
  'home.b2b.stats.pricing': '€49/mo',
  'home.b2b.stats.pricingLabel': 'From 5 clients',

  // B2B CTAs
  'home.b2b.cta.start': 'Get Started Now',
  'home.b2b.cta.viewPricing': 'View Pricing',
  'home.b2b.cta.startNow': 'Start Now',

  // B2B Trust Badges
  'home.b2b.trust.confidential': 'Secure hosting',
  'home.b2b.trust.operational': 'Operational in 2 minutes',
  'home.b2b.trust.support': 'No third-party sharing',

  // B2B Pain Points Section
  'home.b2b.pain.title': 'Public funding search takes too much time',
  'home.b2b.pain.titleHighlight': 'and causes your clients to miss opportunities',
  'home.b2b.pain.solution': 'With Subvention360, turn this administrative monitoring into a competitive advantage.',
  'home.b2b.pain.issue1.title': 'Save valuable time',
  'home.b2b.pain.issue1.description': 'Before: 2-3 hours of manual research per client\nNow: A few minutes to identify all relevant and eligible grants\n→ <strong>Save up to 90% of your time</strong>',
  'home.b2b.pain.issue2.title': 'Never miss an opportunity again',
  'home.b2b.pain.issue2.description': 'Before: High risk of missing grants among {count}+ schemes\nNow: Comprehensive coverage of funding types and new schemes\n→ <strong>Maximize grants obtained for your clients</strong>',
  'home.b2b.pain.issue3.title': 'Enhance your expertise',
  'home.b2b.pain.issue3.description': 'Before: Research work for client projects and scheme identification\nNow: A specialized AI Assistant personalized for each client supports you\n→ <strong>Transform grant research into high-value consulting</strong>',

  // B2B Features Section
  'home.b2b.features.title': 'Discover opportunities your clients don\'t even imagine',
  'home.b2b.features.subtitle': 'A dedicated section bringing together all grants and subsidies available for your clients.',

  'home.b2b.feature1.title': 'The most comprehensive database on the market',
  'home.b2b.feature1.description': 'Over {count} French and European grants • Weekly updates • Comprehensive coverage: European, National, Regional, Local • Detailed sheets with precise eligibility criteria',
  'home.b2b.feature1.badge': 'Automatic matching for your clients',

  'home.b2b.feature2.title': 'Intelligent personalized matching',
  'home.b2b.feature2.description': 'Our algorithm adapts results to each client profile • Real-time analysis of all criteria • Automatic weighting of the most relevant grants • Strategic recommendations by priority',
  'home.b2b.feature2.badge': 'Search in 10 seconds',

  'home.b2b.feature3.title': 'New scheme notifications',
  'home.b2b.feature3.description': 'Be the first to inform your clients • Notification of new schemes as they are published • Information on new schemes matching your client portfolio • Application deadline anticipation',
  'home.b2b.feature3.badge': 'Real-time notifications',

  'home.b2b.feature4.title': 'AI that works for you',
  'home.b2b.feature4.description': 'Our AI automatically analyzes official websites and documents to extract key information • Eligibility criteria, amounts, deadlines identified effortlessly • You focus on consulting, AI does the rest',
  'home.b2b.feature4.badge': 'Native connectors available',

  'home.b2b.feature5.title': 'Centralized multi-client management',
  'home.b2b.feature5.description': 'Manage all your clients from a single dashboard • Multi-collaborator • Multi-client import (Excel - CSV) platform adapts to your file',
  'home.b2b.feature5.badge': 'From 1 to 5,000 clients',

  'home.b2b.feature6.title': 'Client information transmission',
  'home.b2b.feature6.description': 'Generate branded PDF reports • Funding category summaries • One-click multi-grant sending • Communicate relevant opportunities to each client',
  'home.b2b.feature6.badge': 'PDF export in one click',

  // B2B How It Works
  'home.b2b.howItWorks.title': 'Operational in just 2 minutes',
  'home.b2b.howItWorks.subtitle': 'Three steps to start identifying subsidies',

  'home.b2b.howItWorks.step1.title': 'Immediate secure registration',
  'home.b2b.howItWorks.step1.description': 'Simplified form with no commitment • Secure payment setup via SEPA direct debit or credit card • Immediate platform access',

  'home.b2b.howItWorks.step2.title': 'Create your client portfolio',
  'home.b2b.howItWorks.step2.description': 'Manual creation in under 30 seconds per client • Import your Excel/CSV files • Encrypted and secure data',

  'home.b2b.howItWorks.step3.title': 'Discover opportunities',
  'home.b2b.howItWorks.step3.description': 'Automatic identification of all eligible grants • Analysis prioritized by relevance and potential • Specialized AI assistant for complex cases or client projects • Share information with your clients',

  'home.b2b.howItWorks.footer': '100% secure payment • Simple monthly billing • No commitment • Dedicated support included • GDPR protected data',

  // B2B Security Section
  'home.b2b.security.badge': '100% Secure and Confidential',
  'home.b2b.security.title': 'Your data safe and secure, your peace of mind guaranteed',
  'home.b2b.security.subtitle': 'Our certified infrastructure protects your most sensitive information',

  'home.b2b.security.feature1.title': 'Secure sovereign hosting',
  'home.b2b.security.feature1.description': 'Hosted on Supabase infrastructure (SOC 2 certified) • EU servers (Frankfurt) • Multiple automatic backups',

  'home.b2b.security.feature2.title': 'Advanced data protection',
  'home.b2b.security.feature2.description': 'AES-256 algorithms for data at rest • TLS 1.2+ protocols for secure transfers • Secure email and password authentication',

  'home.b2b.security.feature3.title': 'Full regulatory compliance',
  'home.b2b.security.feature3.description': 'Complete GDPR compliance • CNIL directive compliance • Access and action traceability',

  'home.b2b.security.feature4.title': 'Absolute confidentiality',
  'home.b2b.security.feature4.description': 'No data sharing with third parties • No reuse of your information • Your clients remain entirely yours',

  'home.b2b.security.support.title': 'French support included',
  'home.b2b.security.support.subtitle': 'Included in all plans',
  'home.b2b.security.support.item1': 'Email support - Response within 48 business hours',
  'home.b2b.security.support.item2': 'Comprehensive help center with guides',
  'home.b2b.security.support.item3': 'Free onboarding training',
  'home.b2b.security.support.item4': 'Complete documentation regularly updated',

  // B2B Final CTA
  'home.b2b.finalCta.title': 'subvention360 your public funding partner',
  'home.b2b.finalCta.subtitle': 'Dedicated to:',
  'home.b2b.finalCta.description': 'Consulting Firms\nAccounting Firms and their advisory departments\nAudit and Statutory Auditing Firms\nFinancial and Investment Advisors\nIndependent Consultants specialized in funding',
  'home.b2b.finalCta.evolution': 'A continuously evolving solution, with new dedicated services developed regularly.',
  'home.b2b.finalCta.benefitsTitle': 'What you gain today:',
  'home.b2b.finalCta.benefit1': 'Save 2-3 hours of research per client',
  'home.b2b.finalCta.benefit2': 'Access {count}+ grants with automatic matching',
  'home.b2b.finalCta.benefit3': 'Enhance your expertise,\nprofessional PDF reports',
  'home.b2b.finalCta.benefit4': 'Benefit from a scalable solution tailored to your business needs',
  'home.b2b.finalCta.benefit5': 'Grow your consulting revenue',
  'home.b2b.finalCta.guaranteesTitle': 'Your Subvention360 guarantees:',
  'home.b2b.finalCta.guarantee1': '100% secure payment by Stripe - PCI DSS Certified',
  'home.b2b.finalCta.guarantee2': 'Flexible monthly billing adapted to your volume',
  'home.b2b.finalCta.guarantee3': 'No commitment - Cancel anytime in 1 click',
  'home.b2b.finalCta.guarantee4': 'French support by email - Response within 48 business hours',
  'home.b2b.finalCta.guarantee5': 'Regular updates - New services continuously',
  'home.b2b.finalCta.closing': 'Join the ecosystem of professionals innovating in financial support',
  'home.b2b.finalCta.footer1': 'Secure payment by Stripe',
  'home.b2b.finalCta.footer2': 'Volume-based monthly billing',
  'home.b2b.finalCta.footer3': 'Cancel anytime',

  // SEO
  'home.seo.title': 'Subsidy search platform for professionals',
  'home.seo.description': 'B2B platform for consulting firms and accountants. 10,000+ French and European grants and subsidies. Client profile search, PDF exports, multi-client management.',
  'home.seo.keywords': 'consulting subsidies, professional subsidy platform, accountants grants, subsidy search, public funding, business grants, European subsidies',

  // Navigation & UI elements
  'home.b2b.header.features': 'Features',
  'home.b2b.header.company': 'Company',
  'home.b2b.header.dashboard': 'Dashboard',
  'home.b2b.cta.trial': 'Trial',
  'home.b2b.cta.trialFree': 'Free Trial',
  'home.b2b.cta.requestDemo': 'Request a demo',
  'home.b2b.features.exploreAll': 'Explore all features',
  'home.b2b.howItWorks.badge': 'Real-Time Notifications',
  'home.b2b.hero.videoFallback': 'Video demonstration',

  // Feature modal UI
  'home.b2b.modal.keyPoints': 'Key points',
  'home.b2b.modal.tryFree': 'Try for free',
  'home.b2b.modal.screenshot': 'Screenshot',

  // Feature CTAs
  'home.b2b.feature1.cta': 'Explore the database',
  'home.b2b.feature2.cta': 'Discover matching',
  'home.b2b.feature3.cta': 'Enable alerts',
  'home.b2b.feature4.cta': 'Discover the AI',
  'home.b2b.feature5.cta': 'Manage clients',
  'home.b2b.feature6.cta': 'View templates',

  // Feature modal content
  'home.b2b.feature1.modalTitle': 'Comprehensive database',
  'home.b2b.feature1.modalDescription': 'Access the largest grants and subsidies database in France, updated daily by our team and algorithms.',
  'home.b2b.feature1.modalHighlight1': 'Over {count} grant schemes referenced',
  'home.b2b.feature1.modalHighlight2': 'Complete national and regional coverage',
  'home.b2b.feature1.modalHighlight3': 'Daily information updates',
  'home.b2b.feature1.modalHighlight4': 'Detailed sheets with eligibility criteria',

  'home.b2b.feature2.modalTitle': 'Intelligent personalized matching',
  'home.b2b.feature2.modalDescription': 'Our matching algorithm analyzes each client profile to identify the most relevant grants from our database of over {count} schemes.',
  'home.b2b.feature2.modalHighlight1': 'Automatic company profile analysis (sector, size, location)',
  'home.b2b.feature2.modalHighlight2': 'Compatibility score for each identified grant',
  'home.b2b.feature2.modalHighlight3': 'Real-time updates based on profile changes',
  'home.b2b.feature2.modalHighlight4': 'Smart filtering to avoid false positives',

  'home.b2b.feature3.modalTitle': 'New scheme alerts',
  'home.b2b.feature3.modalDescription': 'Never miss an opportunity with our intelligent alert system that notifies you as soon as a new grant matches your client profiles.',
  'home.b2b.feature3.modalHighlight1': 'Real-time notifications for new grants',
  'home.b2b.feature3.modalHighlight2': 'Customized alerts by client or sector',
  'home.b2b.feature3.modalHighlight3': 'Weekly opportunity summary',
  'home.b2b.feature3.modalHighlight4': 'Application deadline alerts',

  'home.b2b.feature4.modalTitle': 'AI that works for you',
  'home.b2b.feature4.modalDescription': 'Our artificial intelligence automatically analyzes official websites and documents to extract key information, saving you valuable time.',
  'home.b2b.feature4.modalHighlight1': 'Automatic eligibility criteria extraction',
  'home.b2b.feature4.modalHighlight2': 'Identification of funding amounts and rates',
  'home.b2b.feature4.modalHighlight3': 'Detection of deadlines and conditions',
  'home.b2b.feature4.modalHighlight4': 'Continuous database enrichment',

  'home.b2b.feature5.modalTitle': 'Centralized multi-client management',
  'home.b2b.feature5.modalDescription': 'Manage your entire client portfolio from a single, intuitive interface with personalized tracking for each one.',
  'home.b2b.feature5.modalHighlight1': 'Unified dashboard for all your clients',
  'home.b2b.feature5.modalHighlight2': 'Complete and customizable company profiles',
  'home.b2b.feature5.modalHighlight3': 'File and opportunity tracking',
  'home.b2b.feature5.modalHighlight4': 'Access rights management by collaborator',

  'home.b2b.feature6.modalTitle': 'Client information transmission',
  'home.b2b.feature6.modalDescription': 'Communicate effectively with your clients using our customized document generation and targeted information sending tools.',
  'home.b2b.feature6.modalHighlight1': 'Generate branded PDF reports',
  'home.b2b.feature6.modalHighlight2': 'Summary by funding category',
  'home.b2b.feature6.modalHighlight3': 'One-click multi-grant sending by email',
  'home.b2b.feature6.modalHighlight4': 'Communication history for each client',

  // Footer
  'home.b2b.footer.description': 'The intelligent platform to manage all your clients\' subsidies and grants in one place.',
  'home.b2b.footer.platform': 'Platform',
  'home.b2b.footer.legal': 'Legal',
  'home.b2b.footer.features': 'Features',
  'home.b2b.footer.pricing': 'Pricing',
  'home.b2b.footer.blog': 'Blog',
  'home.b2b.footer.freeTrial': 'Free trial',
  'home.b2b.footer.legalNotice': 'Legal notice',
  'home.b2b.footer.privacy': 'Privacy',
  'home.b2b.footer.terms': 'Terms',
  'home.b2b.footer.copyright': '© 2025 Subvention360. All rights reserved.',
  'home.b2b.footer.hostedIn': 'Hosted in France',

  // Contact
  'home.b2b.footer.contact': 'Contact Us',
  'home.b2b.footer.contactIntro': 'Have a question? Our team is here to support you with your project.',

  // Blog Page
  'blog.pageTitle': 'Blog - Subsidies News',
  'blog.metaDescription': 'Discover the latest news about subsidies and public funding in France. Tips, analysis and funding opportunities.',
  'blog.title': 'Blog',
  'blog.subtitle': 'Find our latest publications on subsidies and public funding in France',
  'blog.error': 'Error loading articles',
  'blog.noPosts': 'No articles available at the moment',
  'blog.viewOnLinkedIn': 'View on LinkedIn',
  'blog.followCta': 'Follow us on LinkedIn to stay updated',
  'blog.followButton': 'Follow Subvention360',
} as const;